import { render, staticRenderFns } from "./AppraiseInfo.vue?vue&type=template&id=5bc651ac&scoped=true&"
import script from "./AppraiseInfo.vue?vue&type=script&lang=js&"
export * from "./AppraiseInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppraiseInfo.vue?vue&type=style&index=0&id=5bc651ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc651ac",
  null
  
)

export default component.exports